import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { ILocalConfig } from '../../../types/LocalConfig';
import { localConfig } from '../../localConfig';
import { RootState } from '../store';

export interface IGlobalState {
  config: ILocalConfig;
}

const initialState: IGlobalState = {
  config: localConfig,
};

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setConfig: (state: IGlobalState, action: PayloadAction<ILocalConfig>) => {
      state.config = action.payload;
    },
  },
});

export const { setConfig } = globalSlice.actions;
export const selectConfig = (state: RootState) => state.global.config;

export default globalSlice.reducer;
